<template>
  <!-- The Picks page's week: every game in the board's win-% order, read from
       the app's side, with a dashed line under the board's five. Your picks are
       highlighted rows. Thu-Sat games, never ranked, sit in their own group.
       (Results keeps WeekGamesPanel, which still sorts and reads "vs mkt".) -->
  <section class="rounded-2xl border border-white/10 bg-brand-navy/40 p-2.5 shadow-lg shadow-black/15 sm:p-3">
    <header class="flex items-baseline justify-between gap-3 px-0.5 pb-2">
      <h2 class="text-sm font-extrabold text-slate-200">Games</h2>
      <span class="text-[11px] font-bold text-slate-400">{{ counts }}</span>
    </header>
    <p v-if="!games.length" class="py-6 text-center text-xs text-slate-500">No games for this week.</p>
    <div v-for="group in groups" :key="group.key">
      <p v-if="group.key === 'offSlate'" class="mt-3 border-b border-white/[0.08] px-0.5 pb-1.5 text-[9px] font-extrabold tracking-[0.14em] text-slate-400">
        NOT RANKED <span class="font-semibold normal-case tracking-normal text-slate-500">· {{ group.note }}</span>
      </p>
      <ul class="border-t border-white/[0.08]">
        <GamedayRow v-for="row in group.rows.slice(0, group.cutAfter || undefined)" :key="row.id" :row="row" :now="now" :crowd="crowd" :outcomes="outcomes" />
        <li v-if="group.cutAfter" class="cut-line" aria-label="End of the top five"><span>Top 5</span></li>
        <template v-if="group.cutAfter">
          <GamedayRow v-for="row in group.rows.slice(group.cutAfter)" :key="row.id" :row="row" :now="now" :crowd="crowd" :outcomes="outcomes" />
        </template>
      </ul>
    </div>
  </section>
</template>

<script>
import GamedayRow from "./GamedayRow.vue";
import { groupWeekGames } from "@/utils/weekGames.js";
import { gameState } from "@/utils/gameday.js";

export default {
  name: "PicksGamesPanel",
  components: { GamedayRow },
  props: {
    // `analyzeHistoryGame` rows for the week.
    games: { type: Array, required: true },
    // `yourWeekPicks` output, so your games can be highlighted.
    picks: { type: Array, default: null },
    now: { type: Number, default: () => Date.now() },
    // Who in the pool picked what (see GamedayRow).
    crowd: { type: Object, default: null },
    outcomes: { type: Array, default: () => [] },
  },
  computed: {
    groups() {
      return groupWeekGames(this.games, { picks: this.picks, sort: "win" });
    },
    counts() {
      const states = this.games.map(gameState);
      const n = (state) => states.filter((s) => s === state).length;
      if (states.length && n("final") === states.length) {
        const all = this.groups.find((group) => group.key === "all");
        return all ? `${all.record.label} · all final` : "all final";
      }
      const parts = [];
      if (n("live")) parts.push(`${n("live")} live`);
      if (n("final")) parts.push(`${n("final")} final`);
      if (n("pre")) parts.push(`${n("pre")} to come`);
      return parts.join(" · ");
    },
  },
};
</script>

<style scoped>
.cut-line { display: flex; align-items: center; gap: 0.6rem; padding: 0.6rem 0.2rem; color: #34d399; font-size: 0.62rem; font-weight: 900; letter-spacing: 0.2em; text-transform: uppercase; }
.cut-line::before, .cut-line::after { content: ""; flex: 1; border-top: 1px dashed rgb(52 211 153 / 0.4); }
</style>
